import PropTypes from "prop-types";
import React, { useState } from "react";
import NipWrapper from "../../components/Nip/NipWrapper";
import Filter from "../../assets/assets/filter.svg";
import DateFilter from "../../components/DateFilter/DateFilter";
import ReactPaginate from "react-paginate";
import { Dropdown } from "semantic-ui-react";
import { options } from "../../utils/Functions/ApiHistoryIndex";
import { connect } from "react-redux";
import {
  filterDateApiHistory,
  filterStatusApiHistory,
  getAllApiHistory,
} from "../../redux/Actions/ApiHistoryActions";
import { useEffect } from "react";
import Spinner from "react-spinner-material";
import moment from "moment";
import Storage from "../../utils/storage";
import { ApiHistoryTable } from "./ApiHistoryTable";

const ApiHistory = (props) => {
  const {
    getAllApiHistory,
    isLoading,
    apiHistory,
    filterDateApiHistory,
    filterStatusApiHistory,
    filteredDateApiHistory,
    filteredStatusApiHistory,
    isFiltering,
    filterDateApiHistorySuccess,
    filterStatusApiHistorySuccess,
  } = props;
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const [state, setState] = useState({
    selected: 0,
    showMore: false,
    showFilteredDateResults: false,
    showFilteredStatusResults: false,
    offset: 0,
    index: 1,
  });

  useEffect(() => {
    setState({
      showFilteredDateResults: false,
      showFilteredStatusResults: false,
      showMore: false,
      offset: 0,
    });
    let limit = 10;
    let offset = 0;
    getAllApiHistory(limit, offset);
  },
  // eslint-disable-next-line
  [getAllApiHistory]);

  const apis = apiHistory && apiHistory.data;

  useEffect(
    () => {
      if (filterDateApiHistorySuccess) {
        setState({
          showFilteredDateResults: true,
          offset: state.offset,
        });
      }
    },
    // eslint-disable-next-line
    [filterDateApiHistorySuccess]
  );

  useEffect(
    () => {
      if (filterStatusApiHistorySuccess) {
        setState({
          showFilteredStatusResults: true,
          offset: state.offset,
        });
      }
    },
    // eslint-disable-next-line
    [filterStatusApiHistorySuccess]
  );

  const dataLength = (() => {
    if (state.showFilteredDateResults) {
      return (
        filteredDateApiHistory &&
        filteredDateApiHistory.totalCount &&
        parseInt(filteredDateApiHistory.totalCount)
      );
    } else if (state.showFilteredStatusResults) {
      return (
        filteredDateApiHistory &&
        filteredDateApiHistory.totalCount &&
        parseInt(filteredDateApiHistory.totalCount)
      );
    } else {
      return apis && apis.totalCount && parseInt(apis.totalCount);
    }
  })();

  const pageCount = Math.ceil(parseInt(dataLength) / 10);

  const handlePageClick = (data) => {
    let limit = 10;
    let selected = data.selected;
    let offset = Math.ceil(selected * 10);
    setState({
      ...state,
      selected: data.selected,
      offset: offset,
    });
    if (state.showFilteredDateResults) {
      const start_date = Storage.get("start-value");
      const end_date = Storage.get("end-value");
      filterDateApiHistory(limit, offset, start_date, end_date);
    } else if (state.showFilteredStatusResults) {
      const type = Storage.get("status-value");
      filterDateApiHistory(limit, offset, type);
    } else {
      getAllApiHistory();
    }
  };

  const handleDateFilter = () => {
    setState({
      ...state,
      showFilteredStatusResults: false,
    });
    let limit = 10;
    let offset = 0;
    let start = moment(startDate).format("YYYY-MM-DD");
    let end = moment(endDate).format("YYYY-MM-DD");
    Storage.set("start-value", start);
    Storage.set("end-value", end);
    filterDateApiHistory(limit, offset, start, end);
  };

  const handleStatusFilter = (event, data) => {
    let limit = 10;
    let offset = 0;
    if (data.value === 1) {
      let type = "success";
      Storage.set("status-value", type);
      filterStatusApiHistory(limit, offset, type);
    }
    if (data.value === 2) {
      let type = "failure";
      Storage.set("status-value", type);
      filterStatusApiHistory(limit, offset, type);
    }
  };

  const sortedApiHistory = (() => {
    if (state.showFilteredDateResults) {
      return filteredDateApiHistory && filteredDateApiHistory.data;
    } else if (state.showFilteredStatusResults) {
      return filteredStatusApiHistory && filteredStatusApiHistory.data;
    } else {
      return apis;
    }
  })();

  const showDateFilter = () => {
    setState({
      ...state,
      showFilter: (state.showFilter = !state.showFilter),
    });
  };

  const showMoreData = (id) => {
    setState({
      showMore: (state.showMore = !state.showMore),
      index: id,
    });
  };

  let apiHistoryList = "";
  if (isLoading || isFiltering) {
    apiHistoryList = (
      <div className="center-spinner">
        <Spinner size={120} color={"#047558"} spinnerwidth={5} visible={true} />
      </div>
    );
  } else if (sortedApiHistory && sortedApiHistory.length === 0) {
    apiHistoryList = (
      <div className="dashboard-main-content empty2">
        <p>No Api History Found</p>
      </div>
    );
  } else {
    apiHistoryList =
      sortedApiHistory &&
      sortedApiHistory.map((api, index) => {
        return (
          <ApiHistoryTable
            api={api}
            index={index}
            state={state}
            showMoreData={showMoreData}
          />
        );
      });
  }
  return (
    <NipWrapper>
      <div className="api-history-header">
        <h1 className="api-history-header-title">API History</h1>
        <p className="api-history-header-title2">
          This section describes what API keys are and how to retrieve them.
        </p>
      </div>
      <div className="filter-lists">
        <div></div>
        <div className="filter-lists-right">
          <div className="filter-name">
            <img src={Filter} alt="filter" /> &nbsp; Filter By:
          </div>
          <div className="date-main-wrapper">
            <Dropdown placeholder="Date" selection onClick={showDateFilter} />
            {state.showFilter && (
              <DateFilter
                startDate={startDate}
                endDate={endDate}
                setStartDate={setStartDate}
                setEndDate={setEndDate}
                filter={handleDateFilter}
                text="Filter"
              />
            )}
          </div>
          <Dropdown
            placeholder="Status"
            clearable
            options={options}
            selection
            onChange={handleStatusFilter}
          />
        </div>
      </div>

      <div className="api-history-table">{apiHistoryList}</div>

      {(!isLoading || isFiltering) && dataLength > 10 && (
        <ReactPaginate
          previousLabel={"prev"}
          nextLabel={"next"}
          breakLabel={"..."}
          breakClassName={"break-me"}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={handlePageClick}
          containerClassName={"pagination"}
          subContainerClassName={"pages pagination"}
          activeClassName={"active"}
          perPage={10}
          forcePage={state.selected}
        />
      )}
    </NipWrapper>
  );
};

ApiHistory.propTypes = {
  apiHistory: PropTypes.shape({
    data: PropTypes.object,
  }),
  filterDateApiHistory: PropTypes.func,
  filterDateApiHistorySuccess: PropTypes.bool,
  filterStatusApiHistory: PropTypes.func,
  filterStatusApiHistorySuccess: PropTypes.bool,
  filteredDateApiHistory: PropTypes.shape({
    data: PropTypes.object,
    totalCount: PropTypes.number,
  }),
  filteredStatusApiHistory: PropTypes.shape({
    data: PropTypes.object,
  }),
  getAllApiHistory: PropTypes.func,
  isFiltering: PropTypes.bool,
  isLoading: PropTypes.bool,
};

const mapDispatchToProps = (dispatch) => ({
  getAllApiHistory: (limit, offset) =>
    dispatch(getAllApiHistory(limit, offset)),
  filterDateApiHistory: (limit, offset, start_date, end_date) =>
    dispatch(filterDateApiHistory(limit, offset, start_date, end_date)),
  filterStatusApiHistory: (limit, offset, type) =>
    dispatch(filterStatusApiHistory(limit, offset, type)),
});

const mapStateToProps = (state) => ({
  isLoading: state.apiHistory.isLoading,
  getApiHistorySuccess: state.apiHistory.getApiHistorySuccess,
  apiHistory: state.apiHistory.getApiHistory,
  isFiltering: state.apiHistory.isFiltering,
  filteredDateApiHistory: state.apiHistory.filteredDateApiHistory,
  filteredStatusApiHistory: state.apiHistory.filteredStatusApiHistory,
  filterStatusApiHistorySuccess:
    state.apiHistory.filteredStatusApiHistorySuccess,
  filterDateApiHistorySuccess: state.apiHistory.filteredDateApiHistorySuccess,
});

export default connect(mapStateToProps, mapDispatchToProps)(ApiHistory);
